import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { Router } from '@angular/router';

@Component({
    selector: 'app-metric-widget',
    standalone: true,
    imports: [CommonModule, ButtonModule, MenuModule],
    templateUrl: './metric-widget.component.html',
    styleUrls: ['./metric-widget.component.scss']
})
export class MetricWidgetComponent {
     @Input() title!: string;
    @Input() value!: number | string;
    @Input() subtitle?: string;
    @Input() icon = 'pi-chart-line';
    @Input() route?: string;

    @Input() status: 'success' | 'warning' | 'danger' | 'info' = 'info';

    constructor(private router: Router) {}

    get statusBgClass(): string {
        return {
            success: 'bg-green-100 dark:bg-green-400/10',
            warning: 'bg-orange-100 dark:bg-orange-400/10',
            danger: 'bg-red-100 dark:bg-red-400/10',
            info: 'bg-blue-100 dark:bg-blue-400/10'
        }[this.status];
    }

    get statusTextClass(): string {
        return {
            success: 'text-green-500',
            warning: 'text-orange-500',
            danger: 'text-red-500',
            info: 'text-blue-500'
        }[this.status];
    }

    navigate() {
        if (this.route) {
            this.router.navigate([this.route]);
        }
    }
}

